import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import "../styles/login.css";
import { useNavigate } from "react-router-dom";
import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
import Navbar from "../components/Navbar/Navbar";

const Login = () => {
  // Use both login and googleLogin from context
  const { login, googleLogin,setUser } = useAuth();

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [errors, setErrors] = useState({});

  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Normal email/password login using context
  const handleLogin = async (e) => {
    e.preventDefault();
    const { email, password } = formData;

    const newErrors = {};
    if (!email) newErrors.email = "Email is required";
    if (!password) newErrors.password = "Password is required";

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    setErrors({});

    try {
      const result = await login(email, password); // Auth context handles API call
      // result may contain the user or a status field from the server
      if (result && result.status === "success") {
        setUser(result.data); // Set user in context
        navigate("/dashboard/home");
      } else if (result && result.message) {
        alert(result.message || "Login failed. Please try again.");
      }
    } catch (error) {
      console.error("Login error:", error);
      alert("Network or server error. Please try again later.");
    }
  };

  // Google OAuth login handler using context
  const handleGoogleLogin = async (credentialResponse) => {
    try {
      const { credential } = credentialResponse;
      if (!credential) {
        alert("Google authentication failed.");
        return;
      }
      const result = await googleLogin(credential); // Auth context handles API call
      if (result && result.status === "success") {
        setUser(result.data); // Set user in context
        navigate("/dashboard/home");
      } else if (result && result.message) {
        alert(result.message || "Google login failed. Please try again.");
      }
    } catch (err) {
      console.error("Google login error:", err);
      alert("Google login failed. Please try again.");
    }
  };

  return (<>
   <Navbar />
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        padding: "2rem",
      }}
    >

         
      <div className="login-wrapper">
        <div className="login-title-container">
          <h6 className="login-title">WELCOME BACK,</h6>
        </div>

        <div className="googlebtn">
          <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
            <div>
              <GoogleLogin
                onSuccess={handleGoogleLogin}
                onError={() => {
                  console.log("Google Login Failed");
                  alert("Google Login Failed");
                }}
              />
            </div>
          </GoogleOAuthProvider>
        </div>

        <div className="ORText">
          <span>OR</span>
        </div>

        <form className="login-form" noValidate onSubmit={handleLogin}>
          <div className="input-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
            />
            {errors.email && <p className="error-message">{errors.email}</p>}
          </div>

          <div className="input-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
            />
            {errors.password && (
              <p className="error-message">{errors.password}</p>
            )}
          </div>

          <center>
            <div className="loginbtn">
              <button type="submit" className="login-button">
                LOG IN
              </button>
            </div>
            <div className="forgotpass-btn">
              <a href="/forgot-password" className="forgot-password-link">
                Forgot Password?
              </a>
            </div>
          </center>
        </form>
        <div className="spacer"></div>
      </div>
    </div>
    </>
  );
};

export default Login;
